import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import Grid from "@mui/material/Grid2";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
// Compoents
import DeliveryOrderDetailCard from "@/components/deliveryOrderDetailCard";
import ImageZoom from "@/components/imageZoom";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import { getDeliveryOrderItemList } from "@/fetch/fetchStock";

// Moment
import { updateDeliveryOrder } from "@/fetch/fetchStock";
import { useCurrentAction } from "@/hooks/user";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";

const DeliveryOrderDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const { id, si_number } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [deliveryOrderItem, setDeliveryOrderItem] = React.useState({
    images: {},
  });
  const [isZoomFullScreenOpen, setZoomFullScreenOpen] = React.useState(false);
  const [photoSource, setPhotoSource] = React.useState("");
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const fetchAll = async () => {
    if (id) {
      const { data } = await getDeliveryOrderItemList(id, si_number);
      setDeliveryOrderItem(data);
    }
  };
  const handleOnChange = async (event) => {
    try {
      await updateDeliveryOrder(
        deliveryOrderItem.si_number,
        deliveryOrderItem.stockonhand_refill_id,
        event.target.value
      );
      setSnackSeverity("success");
      setSnackMessage("更新成功");
      setDeliveryOrderItem((prev) => ({
        ...prev,
        status: event.target.value,
      }));
    } catch (error) {
      setSnackSeverity("error");
      setSnackMessage("更新失敗");
    } finally {
      setSnackOpen(true);
    }
  };
  const handleClose = () => {
    setZoomFullScreenOpen(false);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="DeliveryOrderDetailPage"
      selectedIndex={20}
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title title={`運送單詳細資料`} history={() => navigate(-1)} />
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 12,
            lg: 12
          }}>
          {deliveryOrderItem.si_number && (
            <DeliveryOrderDetailCard
              actions={actions}
              handleOnChange={handleOnChange}
              deliveryOrderItem={deliveryOrderItem}
              noHover={true}
              type={"shop"}
            />
          )}
        </Grid>

        <Grid size={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>物品名稱</TableCell>
                  <TableCell align="right">運送數量</TableCell>
                  <TableCell align="right">收貨數量</TableCell>
                  <TableCell align="right">差異</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveryOrderItem &&
                  _.map(deliveryOrderItem?.items, (item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.item_name}</TableCell>
                      <TableCell align="right">{item.delivery_qty}</TableCell>
                      <TableCell align="right">
                        {deliveryOrderItem.status === "InTransit" ||
                        deliveryOrderItem.status === "Void"
                          ? "--"
                          : item.actual_qty}
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{
                          color:
                            item.status === "Arrived" &&
                            Number(item.actual_qty) -
                              Number(item.delivery_qty) !==
                              0
                              ? "red"
                              : "black",
                        }}
                      >
                        {item.status === "Arrived"
                          ? Number(item.actual_qty) - Number(item.delivery_qty)
                          : "--"}
                      </TableCell>
                    </TableRow>
                  ))}
                <TableRow>
                  {deliveryOrderItem.images && (
                    <ImageZoom
                      attachments={deliveryOrderItem.images}
                    ></ImageZoom>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default DeliveryOrderDetailPage;
